import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const path = '../oldPages/transfer-statements/statements-pop-up/index.html';

const links: Record<string, string> = {
  back: '/infoTrac/transfer-statements/account-statements',
  destination: '/infoTrac/transfer-statements/destination-account',
};

function AccountStatementsPopUp() {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    document.body.classList.add('lightbox-open');

    const handleIframeLoad = () => {
      const iframeDocument = iframeRef.current?.contentDocument || iframeRef.current?.contentWindow?.document;

      if (!iframeDocument) return;

      const closeModal = iframeDocument.getElementsByClassName('closeBtn');
      const destination = iframeDocument.getElementsByClassName('destinationBtn');

      if (closeModal.length) {
        for (let i = 0; i < closeModal.length; i++) {
          closeModal[i].addEventListener('click', () => navigate(links.back));
        }
      }

      if (destination.length) {
        for (let i = 0; i < destination.length; i++) {
          destination[i].addEventListener('click', () => navigate(links.destination));
        }
      }
    };

    if (iframeRef.current) iframeRef.current.addEventListener('load', handleIframeLoad);

    return () => {
      document.body.classList.remove('lightbox-open');
      if (iframeRef.current) iframeRef.current.removeEventListener('load', handleIframeLoad);
    };
  }, []);

  return (
    <iframe
      ref={iframeRef}
      title="transfer-statements-account-statements-pop-up"
      src={path}
      className="z-[100] relative"
      width="100%"
      height="800px"
    />
  );
}

export default AccountStatementsPopUp;
